import {Component, OnInit} from '@angular/core';
import {TranslateService} from 'ng2-translate';
import {Subscription} from 'rxjs';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-change-language',
  templateUrl: './change-language.component.html',
  styleUrls: []
})
export class ChangeLanguageComponent implements OnInit {
  //  @Input('langChange') langChange :(value: any)=> string;
  private langChange: any = '';
  private currLanguage: string = 'English';
  private subscription: Subscription;

  constructor(private translate: TranslateService, private activatedRoute: ActivatedRoute) {
    translate.addLangs(['en', 'fr', 'fa', 'cn', 'hi']);
    translate.setDefaultLang('en');
    let browserLang = translate.getBrowserLang();
    //  translate.use(browserLang.match(/en|fr|cn|hi|fa/)? browserLang : "fa")
    // translate.use(browserLang);
  }

  ngOnInit() {

    //  alert(this.langChange);
    this.subscription = this.activatedRoute.queryParams.subscribe(
      (param: any) => {
        let locale = param['locale'];
        if (locale !== undefined) {
          this.translate.use(locale);
        }
      }
    );
  }

  alterLanguage(lang) {
    let body = document.getElementsByTagName('body')[0];
    if (lang === 'en') {
      body.classList.remove('smart-rtl');
      body.setAttribute('style', 'font-size: 14px !important;');
      this.currLanguage = 'English';
    }
    if (lang === 'fa') {
      body.classList.add('smart-rtl');
      body.setAttribute('style', 'font-size: 18px !important;');
      this.currLanguage = 'Persian';
    }
    //  $('#ltr').on('click', function (e) {
    //      $('body')
    //        .removeClass('smart-rtl')
    //    });
    //    $('#rtl').on('click', function (e) {
    //      $('body')
    //        .addClass('smart-rtl');
    //    });
    this.translate.use(lang);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/shared/change-language/change-language.component.ts